
const mainRouter = [
    {
        path:'',
        name:'main-index',
        component: () => import(/* webpackChunkName: "about" */ '../views/main/index.vue')
    },
    
]
export default mainRouter